const yearsFilter = () => {
    const $doc = $(document);

	$( '.js-year-filter' ).on('click', 'a', function(e){
		e.preventDefault();

	    if ($('body').hasClass('loading')) {
	    	return;
	    }

	    $('body').addClass('loading');

		$( '.js-year-filter li' ).removeClass('current');
		$(this).parent().addClass('current');

		const year = $(this).data('year');
	    const data = {
	    	year: year,
	    }

	    $.ajax({
	      url: window.location.href,
	      type: 'GET',
	      dataType: 'html',
	      data: data,
	      success: function (data) {
	        let new_content = $(data).find( '.section-listing .section__body' );

	        $doc.find('.section-listing .section__body').html(new_content.html());
	      },
	      error: function (xhr, textStatus, errorThrown) {
	        console.log(textStatus);
	      }
	    }).done(function(data){
	      $('body').removeClass( 'loading' );
        })
	} );

}

yearsFilter();
